// extracted by mini-css-extract-plugin
export default {"header":"Header_header__rkWPW","main-image":"Header_main-image__79XCS"};